/**
 * Domain Model: Auth
 * Defines types and interfaces for authentication
 */

export interface LoginUserData {
  userId: string;
  fullName: string;
  email: string;
  role: string;
  avatarUrl: string;
}

export interface LoginCredentials {
  email: string;
  password: string;
  deviceId: string;
  deviceType: string;
}

export interface LoginResult {
  accessToken: string;
  user: LoginUserData;
}

export interface LoginResponseData {
  accessToken: string;
  refreshToken: string;
  tokenType: string;
  expiresIn: number;
  user: LoginUserData;
}

export interface LoginResponse {
  data: LoginResponseData;
  meta: {
    code: string;
    message: string;
    timestamp: string;
  };
}

/**
 * Custom error class for authentication errors
 */
export class AuthenticationError extends Error {
  constructor(message: string = "User is not authenticated") {
    super(message);
    this.name = "AuthenticationError";
  }
}

